function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47 15.81v8.285h6c1.657 0 3 1.237 3 2.762v30.381C56 58.764 54.657 60 53 60H11c-1.657 0-3-1.236-3-2.762v-30.38c0-1.526 1.343-2.763 3-2.763h6V15.81C17 8.183 23.716 2 32 2c8.284 0 15 6.183 15 13.81zm-24 0v8.285h18V15.81c0-4.577-4.03-8.286-9-8.286s-9 3.71-9 8.285z",
  fill: "url(#password_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#password_svg__filter1_b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 36a4 4 0 014-4h56a4 4 0 014 4v12a4 4 0 01-4 4H4a4 4 0 01-4-4V36z",
  fill: "url(#password_svg__paint1_linear)",
  fillOpacity: 0.6
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#password_svg__filter2_bd)",
  fill: "#fff",
  fillOpacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 46a4 4 0 100-8 4 4 0 000 8zM26 46a4 4 0 100-8 4 4 0 000 8zM42 42a4 4 0 11-8 0 4 4 0 018 0zM50 46a4 4 0 100-8 4 4 0 000 8z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "password_svg__filter0_b",
  x: 0,
  y: -6,
  width: 64,
  height: 74,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "password_svg__filter1_b",
  x: -6,
  y: 26,
  width: 76,
  height: 32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "password_svg__filter2_bd",
  x: 0,
  y: 28,
  width: 64,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.2,
  dy: 0.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_backgroundBlur",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "password_svg__paint0_linear",
  x1: 32,
  y1: 2,
  x2: 32,
  y2: 60,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#243143"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#243143",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "password_svg__paint1_linear",
  x1: 0,
  y1: 52,
  x2: 33.192,
  y2: 8.495,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9E9E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D3D3D3"
})));

function SvgPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,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";
export { SvgPassword as ReactComponent };